import React from 'react';
import kitchenImage from '../../images/kitchen.jpg'; // Adjust the path if necessary
import houvalLogo from '../../images/HouvalDark.png'; // Importing the logo

const FrontCover = ({ propertyData }) => {
  const {
    propertyAddress,
  } = propertyData || {};

  return (
    <div className="w-[794px] h-[1123px] relative flex flex-col justify-between">
      {/* Background Image */}
      <img
        src={kitchenImage}
        alt="Kitchen View"
        className="absolute inset-0 w-full h-full object-cover opacity-20"
      />

      {/* Main Content */}
      <div className="relative z-10 flex flex-grow flex-col justify-center items-center h-full">
        {/* Overlay Content */}
        <div className="bg-white bg-opacity-75 p-6 rounded-md shadow-md flex flex-col items-center text-center">
          {/* Logo */}
          <img
            src={houvalLogo}
            alt="Houval Company Logo"
            className="w-64 h-auto mb-4"
          />

          {/* Report Title */}
          <h1 className="text-4xl font-bold mb-4">House Valuation Report</h1>

          {/* Property Details */}
          <h2 className="text-2xl mb-2">{propertyAddress || 'N/A'}</h2>
        </div>
      </div>
    </div>
  );
};

export default FrontCover;
